import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import Box from '@repo/ui/box'
import { SendIcon } from '@repo/ui/icons'
import Modal, { MODAL_BODY_CLASSNAME } from '@repo/ui/modal'
import Typography from '@repo/ui/typography'

import { AffectedStaffDailyReportInput } from '../../../lib/types/models/affectedStaff/affected-staff-daily-report'
import { mapDailyReportIssues } from '../../../views/staff-personal-space/utils'

type Props = {
  isOpen: boolean
  isLoading?: boolean
  input: AffectedStaffDailyReportInput
  onConfirm: () => void
  onClose: () => void
}

type TitleProps = {
  number: number
  title: string | React.ReactNode
}

const Title = ({ number, title }: TitleProps) => (
  <div className="flex  gap-1">
    <div className="flex items-center justify-center rounded-full w-5 h-5 bg-red-light transform -translate-y-0.5">
      <Typography variant="label-extrabold" className="text-red">
        {number}
      </Typography>
    </div>
    <Typography className="flex-1" variant="label-semibold">
      {title}
    </Typography>
  </div>
)
export default function AffectedStaffDailyReportModal({
  isOpen,
  isLoading,
  input,
  onConfirm,
  onClose
}: Props) {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        icon={SendIcon}
        variant="confirmation"
        size="small"
        isLoading={isLoading}
        title="Êtes-vous sûr de vouloir envoyer ce rapport à LEC ? Une fois envoyé, il ne pourra plus être modifié."
        actionButtonsOptions={{
          confirmText: 'Envoyer à LEC',
          cancelText: 'Annuler',
          onConfirm: onConfirm
        }}
        onCancel={onClose}
      >
        <div className={MODAL_BODY_CLASSNAME}>
          <Box className="flex flex-col gap-4 border border-grey-light rounded-lg">
            <Badge
              text={`Journée du : ${input.date ? DateFormatter.DDMMYYYY(input.date) : '-'}`}
            />
            <div>
              <Title
                number={1}
                title="- Évolution des problèmes évoqués sur les rapports précédents "
              />
              <div className="h-2" />
              <Typography variant="label-medium" className="text-grey-lighter">
                <div
                  dangerouslySetInnerHTML={{
                    __html: input.previousIssuesProgress?.replace(/\n/g, '<br/>') || 'Aucun'
                  }}
                />
              </Typography>
            </div>

            <div>
              <Title
                number={2}
                title="- Avez-vous rencontré des problèmes pour les motifs suivants (réponse obligatoire pour chacun des motifs) "
              />
              <div className="h-2" />
              <Typography variant="small-medium" className="text-grey">
                Si vous estimez que la nature des problèmes est trop importante pour être indiquée
                sur ce document nous vous demandons d’appeler nos bureaux à Paris (01 42 67 20 00).
              </Typography>
              <div className="h-2" />
              <div className="flex flex-wrap gap-1">
                {Object.keys(mapDailyReportIssues).map((key) => {
                  const selected = input[key as keyof AffectedStaffDailyReportInput]
                  return (
                    <Badge
                      key={key}
                      variant={selected ? 'primaryLight' : 'grey'}
                      text={`${mapDailyReportIssues[key as keyof typeof mapDailyReportIssues]} : ${
                        selected ? 'Oui' : 'Non'
                      }`}
                    />
                  )
                })}
              </div>
            </div>

            <div>
              <Title
                number={3}
                title={
                  <>
                    - IMPERATIF : Si vous avez coché "oui" à la question 2 : <br />
                    Précisez ci-dessous le nom du ou des jeune(s) / membre de l'encadrement
                    concerné(s), la nature du problème et la date/heure + nom de la personne qui a
                    appelé les parents.
                  </>
                }
              />
              <div className="h-2" />
              <Typography variant="label-medium" className="text-grey-lighter">
                <div
                  dangerouslySetInnerHTML={{
                    __html: input.incidentDetails?.replace(/\n/g, '<br/>') || 'Aucun'
                  }}
                />
              </Typography>
            </div>
          </Box>
        </div>
      </Modal>
    </div>
  )
}
